(() => {
  const floatingCart = document.querySelector('[data-ct-floating-cart]');
  if (!floatingCart) return;

  const countElement = floatingCart.querySelector('[data-ct-floating-cart-count]');
  const headerCart = document.getElementById('cart-icon-bubble');
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  const revealOffset = 300;
  let scrollTicking = false;

  const updateVisibility = () => {
    const isVisible = mobileMedia.matches && window.scrollY > revealOffset;
    floatingCart.classList.toggle('is-visible', isVisible);
    floatingCart.setAttribute('aria-hidden', String(!isVisible));
    floatingCart.tabIndex = isVisible ? 0 : -1;
  };

  const requestVisibilityUpdate = () => {
    if (scrollTicking) return;

    scrollTicking = true;
    window.requestAnimationFrame(() => {
      updateVisibility();
      scrollTicking = false;
    });
  };

  const updateCount = () => {
    if (!countElement || !headerCart) return;

    const countSource =
      headerCart.querySelector('.ct-header-action__cart-count') ||
      headerCart.querySelector('.cart-count-bubble [aria-hidden="true"]') ||
      headerCart.querySelector('.cart-count-bubble');
    const count = Number.parseInt(countSource?.textContent?.match(/\d+/)?.[0] || '0', 10);

    countElement.textContent = String(count);
    countElement.hidden = count < 1;
    floatingCart.setAttribute('aria-label', count > 0 ? `My cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'My cart');
  };

  updateVisibility();
  updateCount();

  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
  mobileMedia.addEventListener?.('change', updateVisibility);

  if (headerCart) {
    new MutationObserver(updateCount).observe(headerCart, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();
